///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.price_change = abcsetup.price_change || {};
abcsetup.price_change.workflow = abcsetup.price_change.workflow || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.price_change.workflow.itemTimeout = null;
abcsetup.price_change.workflow.price_change_id = 0;
abcsetup.price_change.workflow.items = [];




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.price_change.workflow = {
    init: function() {
        abcsetup.setTitle('Approve Price Change');

        // Approval all button clicked
        $(document).on('click', '#btn-approve-all', function (e) {
            $('.btn-options :radio[value="gsmd_approved"]').parent().trigger('change').trigger('click');
            //$("html, body").animate({ scrollTop: 0 });
        });

        // Approval all button clicked
        $(document).on('click', '#btn-reject-all', function (e) {
            $('.btn-options :radio[value="gsmd_rejected"]').parent().trigger('change').trigger('click');
        });

        // Approval all button clicked
        $(document).on('click', '#btn-unmark-all', function (e) {
            $('.btn-options :radio').parent().removeClass('active');
            $('.btn-options :radio').attr('checked', false).trigger('change').trigger('click');
        });

        // Relink button clicked
        $(document).on('click', '.btn.btn-link', function (e) {
            abcsetup.price_change.workflow.linkItem($(this).data('id'));
        });

        // Remove item button clicked
        $(document).on('click', '.btn.btn-remove-item', function (e) {
            $(this).closest('tr.first').next().fadeOut('slow', function() {
                $(this).remove();
            });
            $(this).closest('tr.first').fadeOut('slow', function() {
                $(this).remove();

                if ($('#new_items_table tr').length <= 2) {
                    $('#new_items_table').hide();
                }
            });
        });

        // Pricing modal hidden
        $('.pricing-modal').on('hidden.bs.modal', function (e) {
            $('.tooltips, .btn[title]').tooltip('hide');
        });

        // Show the add item modal
        $('#add-btn').click(function() {
            abcsetup.price_change.workflow.addItem();
        });

        // Show the add item modal
        $('.edit-item-btn').click(function() {
            abcsetup.price_change.workflow.editItem($(this).data('id'));
        });

        // Approve/Reject/Ignore button changed
        $(document).on('change', '.btn-options input', function (e) {
            $('.tooltips, .btn[title]').tooltip('hide');

            $(this).closest('tr').removeClass('gsmd_approved gsmd_rejected gsmd_ignored');
            $(this).closest('tr').next().removeClass('gsmd_approved gsmd_rejected gsmd_ignored');
            $(this).closest('tr').addClass($(this).val());
            $(this).closest('tr').next().addClass($(this).val());

            $(this).closest('tr').find('.btn').removeClass('btn-outline-success btn-outline-danger');

            // Set form field requirements
            $(this).closest('tr').next().find('select.reason-code').attr('required', false);
            $(this).closest('tr').next().find('textarea.reject_reason').attr('required', false);
            $(this).closest('tr').next().find('input.effective_date').attr('required', false);

            if ($(this).val() == 'gsmd_approved') {
                $(this).closest('.btn').addClass('btn-outline-success');

                // Set form field requirements
                //$(this).closest('tr').next().find('select.reason-code').attr('required', true);
                $(this).closest('tr').next().find('input.effective_date').attr('required', true);
            }

            if ($(this).val() == 'gsmd_rejected') {
                $(this).closest('.btn').addClass('btn-outline-danger');

                // Set form field requirements
                $(this).closest('tr').next().find('textarea.reject_reason').attr('required', true);
                $(this).closest('tr').next().find('input.effective_date').attr('required', true);
            }
        });

        $('table.price_change .btn-options input:checked').trigger('change');

        // Global Effective Date changed
        $('#global_date').change(function() {
            if ($(this).val() != '') {
                $('input.effective_date').val($(this).val());
            }
        });

        // Global Reason Code changed
        $('#global_reason_code').change(function() {
            if ($(this).val() != '') {
                $('select.reason-code').val($(this).val());
            }
        });

        // Item modal hidden
        $('#item-modal').on('hidden.bs.modal', function (e) {
            $('#item-modal').find('#results').data('searchString', '');
        });

        // Item modal field(s) changed
        $('#item-modal input, #item-modal select').bind('change keyup', function() {
            clearTimeout(abcsetup.price_change.workflow.itemTimeout);

            abcsetup.price_change.workflow.itemTimeout = setTimeout(function() {
                abcsetup.price_change.workflow.findItems();
            }, 500);
        });

        // External includes
        require('./_new_item');

        // Disable fields that GSMD can't edit
        if (abcsetup.userRole.class == 'gsmd_team') {
            $('td.details:not(.gsmd_in_process) table.cost-table input').attr('disabled', true);
            $('#new_item_table input[name*="[case_pack_quantity]"]').attr('disabled', true);
        }

        // Update the fields
        $('table.cost-table input').trigger('change');
    },


    /**
     * Show the add item modal
     */
    addItem: function() {
        abcsetup.price_change.workflow.price_change_id = 0;
        $('#item-modal .modal-title').html('Search and Add Items to Price Change');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').html('');

        $('#item-modal').modal('show');
    },


    /**
     * Show the edit item modal
     */
    editItem: function(id) {
        abcsetup.price_change.workflow.price_change_id = id;
        $('#item-modal .modal-title').html('Manually Link Item');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').html('');

        $('#item-modal').modal('show');
    },


    /**
     *
     */
    findItems: function() {
        var identifier = $('#item-modal').find('#identifier').val();
        var mfr_prod_code = $('#item-modal').find('#mfr_prod_code').val();
        var mat_descr = $('#item-modal').find('#mat_descr').val();
        var category = $('#item-modal').find('#category').val();
        var limit_vendor = '';

        abcsetup.price_change.workflow.items = [];

        // No search params are specified
        if (identifier == '' && mfr_prod_code == '' && mat_descr == '' && category == '') {
            $('#item-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = identifier + mfr_prod_code + mat_descr + category;
        if ($('#item-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#item-modal').find('#results').data('searchString', searchString);

        // We're not re-linking an item, limit the items to the current vendor
        if (abcsetup.price_change.workflow.price_change_id == 0) {
            limit_vendor = $('#org_id').val();
        }

        // Block the UI with a spinner
        abcsetup.blockUI(true);

        axios.get('/api/price_change/search?identifier=' + identifier + '&mfr_prod_code=' + mfr_prod_code + '&mat_descr=' + mat_descr + '&category=' + category + '&limit_vendor=' + limit_vendor).then(response => {
            abcsetup.unblockUI();

            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>SAP #</th>\
                                        <th>UPC</th>\
                                        <th>COR 6-Digit Item #</th>\
                                        <th>Mfg. Part Number</th>\
                                        <th>Supplier</th>\
                                        <th>Description</th>\
                                        <th>Category</th>\
                                        <th>Mat. Status</th>\
                                        <th>In Planogram</th>\
                                        <th>Predon. Planogram</th>\
                                        <th>Program Code</th>\
                                        <th></th>\
                                    </tr>\
                                </thead>';

            $(response.data).each(function() {
                var row_class = '';
                var button = '<button type="button" class="btn btn-primary btn-link btn-sm" data-id="' + this.id + '">Add</button>';
                // We're re-linking an item
                if (abcsetup.price_change.workflow.price_change_id > 0) {
                    var button = '<button type="button" class="btn btn-warning btn-link btn-sm" data-id="' + this.id + '">Re-link</button>';
                }

                abcsetup.price_change.workflow.items[this.id] = this;

                // The item exists in a price change already
                if (abcsetup.price_change.workflow.items[this.id].price_change_items.length) {
                    row_class = 'disabled';
                    //Workflows: 1467 Create Date: 09/13/2019 10:16 AM
                    button = '<center><i class="fas fa-exclamation-circle fa-2x tooltips" title="This item is already part of a Price Change"></i></center>';
                }

                html = html + '<tr class="' + row_class + '">\
                                    <td>' + this.sap_num + '</td>\
                                    <td>' + ((this.upc11 != null) ? this.upc11 : '') + '</td>\
                                    <td>' + ((this.abc_6_digit != null) ? this.abc_6_digit : '') + '</td>\
                                    <td>' + ((this.mfr_prod_code != null) ? this.mfr_prod_code : '') + '</td>\
                                    <td>' + this.org.name + '<br>' + this.org.vendor_id + '</td>\
                                    <td>' + ((this.mat_descr != null) ? this.mat_descr : '') + '</td>\
                                    <td>' + ((this.a_b_c_fineline != null) ? this.a_b_c_fineline.category_name : '') + '</td>\
                                    <td>' + ((this.mat_status != null) ? this.mat_status : '') + '</td>\
                                    <td>' + ((this.planogram != null) ? this.planogram : '') + '</td>\
                                    <td>' + ((this.pog_predom != null) ? this.pog_predom : '') + '</td>\
                                    <td>' + ((this.program_code != null) ? this.program_code : '') + '</td>\
                                    <td nowrap>' + button + '</td>\
                                </tr>';
            });

            if (!response.data.length) {
                html = html + '<tr><td colspan="12" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#item-modal').find('#results').html(html);

            // Apply the highlighting
            var body = $('#item-modal').find('#results tbody');
            body.unhighlight();

            category = category ? $('#item-modal').find('#category option:selected').text() : '';
            body.highlight([identifier, mfr_prod_code, mat_descr, category]);
        });
    },


    /**
     * Add or re-link item
     */
    linkItem: function(id) {
        //alert(JSON.stringify(abcsetup.price_change.workflow.items[id]));

        // Check if the item already exists in the price change
        if ($('input.item_id[value="' + abcsetup.price_change.workflow.items[id].id + '"]').length > 0) {
            abcsetup.alerts.show('Item already exists', 'This item is already part of this Price Change');
            return false;
        }

        // Add a new item at the end of the price_change table
        if (abcsetup.price_change.workflow.price_change_id == 0) {
            abcsetup.price_change.workflow.price_change_id = abcsetup.price_change.workflow.appendItem(id);
        }

        $('#item_id_' + abcsetup.price_change.workflow.price_change_id).val(id);
        var second_row = $('#item_id_' + abcsetup.price_change.workflow.price_change_id).closest('tr');
        var first_row = second_row.prev();

        // Update first row values
        first_row.find('.identifier').val(abcsetup.price_change.workflow.items[id].upc11);
        first_row.find('.mfg_part_num').val(abcsetup.price_change.workflow.items[id].mfr_prod_code);
        first_row.find('.mat_descr').val(abcsetup.price_change.workflow.items[id].mat_descr);
        first_row.find('.supplier_descr').val(abcsetup.price_change.workflow.items[id].mat_descr);

        first_row.find('.abcitem_identifier').html(abcsetup.price_change.workflow.items[id].upc11);
        first_row.find('.abcitem_mfg_part_num').html(abcsetup.price_change.workflow.items[id].mfr_prod_code);
        first_row.find('.abcitem_sap_num').html(abcsetup.price_change.workflow.items[id].sap_num);
        first_row.find('.abcitem_upc11').html(abcsetup.price_change.workflow.items[id].upc11);

        if (abcsetup.price_change.workflow.items[id].sub_categories.length > 0) {
            first_row.find('.abcitem_subcategories').html(abcsetup.price_change.workflow.items[id].sub_categories[0].category_name);
        }

        first_row.find('.abcitem_mat_descr').html(abcsetup.price_change.workflow.items[id].mat_descr);
        first_row.find('.abcitem_org').html(abcsetup.price_change.workflow.items[id].org.name + '<br><b>' + abcsetup.price_change.workflow.items[id].org.vendor_id + '</b>');
        first_row.find('.abcitem_wholesale_unit').html(abcsetup.price_change.workflow.items[id].wholesale_unit);
        first_row.find('.abcitem_order_unit').html(abcsetup.price_change.workflow.items[id].order_unit);
        first_row.find('.abcitem_gnp').html(abcsetup.price_change.workflow.items[id].gnp);
        first_row.find('.abcitem_priv_label_code').html(abcsetup.price_change.workflow.items[id].priv_label_code);

        // Update second row values
        second_row.find('div.alert').remove();
        second_row.find('.abcitem_case_pack_qty').html(abcsetup.price_change.workflow.items[id].case_pack_qty);

        // Hide and reset the modal
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').modal('hide');

        // Update the fields
        this.setItemPricing(id);
        second_row.find('input').trigger('change');
    },


    /**
     * Add a new item at the end of the price_change table
     */
    appendItem: function(id) {
        var item_id = $('table.price_change tr.first').length * -1;
        var first_row = $('table.price_change:visible tr.first:last').clone();
        var second_row = $('table.price_change:visible tr.second:last').clone();
        var existing_id = second_row.find('input.price_change_id').val();

        var cost_table = $('#new_item_table').html();
        second_row.find('td.cost-cell').html(cost_table);

        // Update the rows HTML
        var html = '<tr class="first new_item">' + first_row.html() + '</tr>';
        html = html + '<tr class="second new_item">' + second_row.html() + '</tr>';
        html = abcsetup.replaceAll(html, '[' + existing_id + ']', '[' + item_id + ']');
        html = abcsetup.replaceAll(html, '"' + existing_id + '"', '"' + item_id + '"');
        html = abcsetup.replaceAll(html, '_' + existing_id + '"', '_' + item_id + '"');
        html = abcsetup.replaceAll(html, '"' + existing_id + '_', '"' + item_id + '_');
        html = abcsetup.replaceAll(html, '_ID_', item_id);

        // Append the new row
        $('#new_items_table').append(html).show();

        // Reset the effective date and reject reason
        $('input[name="fields[' + item_id + '][effective_date]"]').val('');
        $('textarea[name="fields[' + item_id + '][reject_reason]"]').val('');

        return item_id;
    },


    /**
     *
     */
    setItemPricing: function(id) {
        var list_price = (abcsetup.price_change.workflow.items[id]['old_list_price'] ? abcsetup.price_change.workflow.items[id]['old_list_price'] : (abcsetup.price_change.workflow.items[id]['zblp'] ? abcsetup.price_change.workflow.items[id]['zblp'] : ''));
        var net_price = (abcsetup.price_change.workflow.items[id]['old_net_price'] ? abcsetup.price_change.workflow.items[id]['old_net_price'] : (abcsetup.price_change.workflow.items[id]['supernet_price'] ? abcsetup.price_change.workflow.items[id]['supernet_price'] : ''));
        var srp = (abcsetup.price_change.workflow.items[id]['old_srp'] ? abcsetup.price_change.workflow.items[id]['old_srp'] : (abcsetup.price_change.workflow.items[id]['zbsp'] ? abcsetup.price_change.workflow.items[id]['zbsp'] : ''));

        // Logic to determine Case Cost, Unit Cost and Case Pack Qty.
        var case_pack_qty = abcsetup.price_change.workflow.items[id].case_pack_qty;

        switch (abcsetup.price_change.workflow.items[id].order_unit) {
            // FIXME: Check logic
            case 'EA':
                // wholesale_units ('EA','CS','PK','DL')
                // pboo = unit_cost
                var unit_cost = abcsetup.price_change.workflow.items[id]['pboo'];
                var unit_cost_pr = abcsetup.price_change.workflow.items[id]['pr_pboo'];
                var unit_cost_hawaii = abcsetup.price_change.workflow.items[id]['ha_pboo'];

                if (abcsetup.price_change.workflow.items[id]['wholesale_unit'] == 'EA') {
                    var case_cost = unit_cost * case_pack_qty;
                    var case_cost_pr = unit_cost_pr * case_pack_qty;
                    var case_cost_hawaii = unit_cost_hawaii * case_pack_qty;
                } else if (abcsetup.price_change.workflow.items[id]['wholesale_unit'] == 'CS') {
                    var case_cost = abcsetup.price_change.workflow.items[id]['wac'];
                    var case_cost_pr = abcsetup.price_change.workflow.items[id]['pr_zwac'];
                    var case_cost_hawaii = abcsetup.price_change.workflow.items[id]['ha_zwac'];
                    // unit_cost = case_cost / case_pack_qty;
                }
                break;

            case 'CS':
                // wholesale_units ('EA','CS','PK','DL')
                // pboo = case_cost
                //var unit_cost = abcsetup.price_change.workflow.items[id]['pboo'];
                var case_cost = abcsetup.price_change.workflow.items[id]['pboo'];
                var case_cost_pr = abcsetup.price_change.workflow.items[id]['pr_pboo'];
                var case_cost_hawaii = abcsetup.price_change.workflow.items[id]['ha_pboo'];
                // unit_cost = abcsetup.price_change.workflow.items[id]['wac'];
                // case_pack_qty = case_cost / unit_cost;
                break;

            case 'PK':
                // wholesale_units ('EA','PK')
                var unit_cost = abcsetup.price_change.workflow.items[id]['wac'];
                var unit_cost_pr = abcsetup.price_change.workflow.items[id]['pr_zwac'];
                var unit_cost_hawaii = abcsetup.price_change.workflow.items[id]['ha_zwac'];
                var case_cost = unit_cost * case_pack_qty;
                var case_cost_pr = unit_cost_pr * case_pack_qty;
                var case_cost_hawaii = unit_cost_hawaii * case_pack_qty;
                break;

            case 'DL':
                // wholesale_unit always DL
                // var unit_cost = abcsetup.price_change.workflow.items[id]['wac'];
                // case_cost = unit_cost * case_pack_qty;
                break;

            case 'DZ':
                // wholesale_unit always EA
                // wac is the unit_cost
                // case_pack_qty always mltpl of 12
                // case_cost = wac*case_pack_qty
                var unit_cost = abcsetup.price_change.workflow.items[id]['wac'];
                var unit_cost_pr = abcsetup.price_change.workflow.items[id]['pr_zwac'];
                var unit_cost_hawaii = abcsetup.price_change.workflow.items[id]['ha_zwac'];
                var case_cost = unit_cost * case_pack_qty;
                var case_cost_pr = unit_cost_pr * case_pack_qty;
                var case_cost_hawaii = unit_cost_hawaii * case_pack_qty;
                break;

            default:
                break;
        }

        /*
        $uuid = $_REQUEST['uuid'];

        $bracket_types = [
            [
                'type' => 'dollars',
                'type_val' => 'bracket_dollars',
                'brackets' => 6,
                'headings' => ['min' => lang_text('price_change_bb_min_price'), 'max' => lang_text('price_change_bb_max_price')],
                'attr' => 'min="0" step="0.01"',
                'prepend' => '$',
            ],
            [
                'type' => 'qty',
                'type_val' => 'bracket_qty',
                'brackets' => 6,
                'headings' => ['min' => lang_text('price_change_bb_min_qty'), 'max' => lang_text('price_change_bb_max_qty')],
                'attr' => 'min="0" step="1"',
                'prepend' => '',
            ],
            [
                'type' => 'weight',
                'type_val' => 'bracket_weight',
                'brackets' => 6,
                'headings' => ['min' => lang_text('price_change_bb_min_lbs'), 'max' => lang_text('price_change_bb_max_lbs')],
                'attr' => 'min="0" step="0.01"',
                'prepend' => '',
            ],
            [
                'type' => 'break',
                'type_val' => 'break',
                'brackets' => 6,
                'headings' => ['min' => lang_text('price_change_bb_min_qty'), 'max' => lang_text('price_change_bb_max_qty')],
                'attr' => 'min="0" step="1"',
                'prepend' => '',
            ]
        ];
        $bb_div = '
        <div id="bb_pricing_container">
        <input type="hidden" name="fields['.$uuid.'][bracket_break_pricing]" value=""/>';

        foreach ($bracket_types as $i => $bracket) {
            $bb_div .= '
                <div id="bracket_pricing_'.$bracket['type'].'_'.$uuid.'" style="display:none" >
                <table class="tabular-form">
                    <thead>'.'<tr><td colspan="5" title="'.lang_text('tooltip_bracket_pricing_'.$bracket['type']).'"><h1>'.lang_text('price_change_bracket_pricing_'.$bracket['type']).'</h1></td></tr>'.
                        '<tr>
                            <th>'.lang_text('price_change_bb_bracket').'</th>
                            <th>'.$bracket['headings']['min'].'</th>
                            <th>'.$bracket['headings']['max'].'</th>
                            <th>'.lang_text('price_change_bb_uom').'</th>
                            <th>'.lang_text('price_change_bb_uom_cost').'</th>
                        </tr>
                    </thead>
                    <tbody>';
            for ($i=1; $i <= $bracket['brackets']; $i++) {
                $value = '';
                $readonly = $_readonly;
                $class= $_readonly;
                $required_span = '';
                if ($i == 1) {
                $value = 0;
                $class= 'readonly';
                $readonly = 'readonly';
                $required_span = '<span class="input_required_indicator">*</span>';
                }
                else {
                if ($i == 2) {
                    $required_span = '<span class="input_required_indicator">*</span>';
                }
                $value = ($bracket['type']=='break' ||  $bracket['type']=='qty' ? (int)$item['bracket_'.($i).'_min'] : $item['bracket_'.($i).'_min']);
                $value = ($value ? $value : "");
                }

                $bb_div .= '
                        <tr data-item-id="'.$i.'">
                            <input type="hidden" data-item="'.$id.'" data-type="'.$bracket['type'].'" data-field="type" data-uuid="'.$uuid.'" name="fields['.$uuid.'][bracket_break_pricing]['.$bracket['type'].']['.$i.'][type]" value="'.$bracket['type_val'].'"/>
                            <td>'.$i.'
                            <input type="hidden" data-item="'.$id.'" data-type="'.$bracket['type'].'" data-field="bracket" data-uuid="'.$uuid.'" name="fields['.$uuid.'][bracket_break_pricing]['.$bracket['type'].']['.$i.'][bracket]" value="'.$i.'"/>
                            </td>
                            <td class="'.$class.'">'.$bracket['prepend'].'
                            <input class="'.$bracket['type'].' '.$class.'" type="number" data-item="'.$id.'" data-type="'.$bracket['type'].'" data-field="min_price" data-uuid="'.$uuid.'" '.$bracket['attr'].' name="fields['.$uuid.'][bracket_break_pricing]['.$bracket['type'].']['.$i.'][min_price]" value="'.$value.'" '.$readonly.' style="width:6ex"/>
                            '.$required_span.'
                            </td>
                            <td class="">'.$bracket['prepend'].'
                            <input class="'.$bracket['type'].' '.$_readonly.'" type="number" data-item="'.$id.'" data-type="'.$bracket['type'].'" data-field="max_price" data-uuid="'.$uuid.'" '.$bracket['attr'].' name="fields['.$uuid.'][bracket_break_pricing]['.$bracket['type'].']['.$i.'][max_price]" value="'.($bracket['type']=='break' ||  $bracket['type']=='qty' ? (int)$item['bracket_'.($i).'_max'] : $item['bracket_'.($i).'_max']).'" '.$_readonly.' style="width:9ex"/>
                            '.$required_span.'
                            </td>
                            <td class="uom">'.$item['bracket_'.($i).'_uom'].'</td>
                            <td class="'.$class.'">'.$bracket['prepend'].'
                            <input class="'.$bracket['type'].' '.$class.'" type="number" min="0" step="0.01" data-item="'.$id.'" data-type="'.$bracket['type'].'" data-field="uom_cost" data-uuid="'.$uuid.'" name="fields['.$uuid.'][bracket_break_pricing]['.$bracket['type'].']['.$i.'][uom_cost]" value="'.$item['bracket_'.($i).'_uom_price'].'" '.$readonly.'  style="width:9ex"/>
                            '.$required_span.'
                            </td>
                        </tr>';
            }
            $bb_div .= '
                    </tbody>
                </table>
                </div>';
        }
        $bb_div .= '
        </div>';

        $field_names = [
            'bracket_pricing_info'  => ['name' => 'fields['.$uuid.'][bracket_pricing_info]',],
            'break_pricing_info'    => ['name' => 'fields['.$uuid.'][break_pricing_info]',],
            'bracket_type'          => ['name' => 'fields['.$uuid.'][bracket_type]',],
        ];
        $field_values = [
            'bracket_pricing_info'  => ['value' => '',],
            'break_pricing_info'    => ['value' => '',],
            'bracket_type'          => ['value' => ($item['bracket_type'] ? $item['bracket_type'] : ''),],
        ];
        */

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][price_change]"]').val($('#price_change_id').val());
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][identifier]"]').val(abcsetup.price_change.workflow.items[id].upc11);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][mfg_part_num]"]').val(abcsetup.price_change.workflow.items[id].mfr_prod_code);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][mat_descr]"]').val(abcsetup.price_change.workflow.items[id].mat_descr);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][supplier_descr]"]').val(abcsetup.price_change.workflow.items[id].mat_descr);

        // Set the new price change item values
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported]"]').val(0);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_list_price]"]').val(list_price);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_net_price]"]').val(net_price);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_srp]"]').val(srp);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_case_cost]"]').val(case_cost);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][case_cost]"]').val(case_cost).parent().find('.trend').html(case_cost);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_unit_cost]"]').val(unit_cost);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][unit_cost]"]').val(unit_cost).parent().find('.trend').html(unit_cost);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_case_cost_pr]"]').val(case_cost_pr);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][case_cost_pr]"]').val(case_cost_pr).parent().find('.trend').html(case_cost_pr);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_unit_cost_pr]"]').val(unit_cost_pr);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][unit_cost_pr]"]').val(unit_cost_pr).parent().find('.trend').html(unit_cost_pr);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_case_cost_hawaii]"]').val(case_cost_hawaii);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][case_cost_hawaii]"]').val(case_cost_hawaii).parent().find('.trend').html(case_cost_hawaii);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_unit_cost_hawaii]"]').val(unit_cost_hawaii);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][unit_cost_hawaii]"]').val(unit_cost_hawaii).parent().find('.trend').html(unit_cost_hawaii);

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_case_pack_qty]"]').val(case_pack_qty);
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][case_pack_quantity]"]').val(case_pack_qty).parent().find('.trend').html(case_pack_qty);

        //<input type="hidden" name="fields[_ID_][imported_case_cost]" value="'.$item['imported_case_cost'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_unit_cost]" value="'.$item['imported_unit_cost'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_case_cost_pr]" value="'.$item['imported_case_cost_pr'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_unit_cost_pr]" value="'.$item['imported_unit_cost_pr'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_case_cost_hawaii]" value="'.$item['imported_case_cost_hawaii'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_unit_cost_hawaii]" value="'.$item['imported_unit_cost_hawaii'].'"/>'.
        //<input type="hidden" name="fields[_ID_][imported_case_pack_qty]" value="'.$item['imported_case_pack_qty'].'"/>';
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_case_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_unit_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_case_cost_pr]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_unit_cost_pr]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_case_cost_hawaii]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_unit_cost_hawaii]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][imported_case_pack_qty]"]').val('');

        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_1_uom_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_2_uom_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_3_uom_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_4_uom_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_5_uom_cost]"]').val('');
        $('input[name="fields[' + abcsetup.price_change.workflow.price_change_id + '][old_bracket_6_uom_cost]"]').val('');
    }
}
